import {UIProfileController} from '../../../shared/scripts/profile/UIProfileController'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {UserLoginState} from '../../../../shared/UserLoginState'
import {UIProfileFriendsController} from '../../../shared/scripts/profile/UIProfileFriendsController'
import {UIWProfileSettingsController} from './UIWProfileSettingsController'
import {UIProfileRankedSeasonDropdownController} from '../../../shared/scripts/profile/UIProfileRankedSeasonDropdownController'
import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {createImgIn, setElementInnerHTML} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIComponentSearchController} from '../../../shared/scripts/ui_components/UIComponentSearchController'
import {UIAjaxWrapper} from '../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints'
import {getProfileURI} from '../../../shared/scripts/ui_utils/TestableClientUtils'
import {UIProfileGameHistoryController} from '../../../shared/scripts/profile/UIProfileGameHistoryController'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {clientI18n} from '../../../shared/scripts/ClientI18n'
import {UIProfileRankedController} from '../../../shared/scripts/profile/UIProfileRankedController'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'

export class UIWProfileController extends UIProfileController {
    private readonly usernameHeader = document.getElementById('sticky_player_info_username') as HTMLHeadingElement
    private readonly stickyPlayerInfoIcon = document.getElementById('sticky_player_info_icon') as HTMLDivElement
    private readonly stickyPlayerTextContainer = document.getElementById('sticky_player_info_text_container') as HTMLDivElement

    private rankedController: UIProfileRankedController
    settingsController: UIWProfileSettingsController
    private gameHistoryController: UIProfileGameHistoryController
    friendsController: UIProfileFriendsController

    constructor() {
        super()
        this.username = this.getUsername()
        document.title = clientI18n.t('strings:profilePage.pageHeadInfo.title', {username: this.username, interpolation: {escapeValue: false}})
        this.initControllers()
        this.init()
    }

    private initControllers() {
        new UIComponentSearchController('profile_search', '', (searchTerm: string) => UIWProfileController.searchCallBack(searchTerm))
        this.rankedController = new UIProfileRankedController(this.username, UIUtilsEjsVariables.isUserOnMobileApp)
        this.gameHistoryController = new UIProfileGameHistoryController()
        this.friendsController = new UIProfileFriendsController(this.username, this.profileLinkController, this.stickyPlayerTextContainer)
        this.settingsController = new UIWProfileSettingsController(this.getUsername(), this.profileLinkController)
    }

    private static async searchCallBack(searchTerm: string) {
        if(searchTerm == '') return
        const encodedSearchTerm = encodeURIComponent(searchTerm)
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.overview(encodedSearchTerm), undefined)
        if(response == undefined) return

        const profileData = response.json as AjaxDataTypes.PublicProfileDataOverview
        navigateToPage(getProfileURI(profileData.username))
    }

    // eslint-disable-next-line class-methods-use-this
    getUsername(): string {
        if(UIUtilsEjsVariables.isUserOnDiscord) return ClientUserState.userState?.username ?? ''
        const path = window.location.pathname
        const pathSegments = path.split('/')
        const usernamePathSegment = pathSegments[pathSegments.length - 1]
        return decodeURIComponent(usernamePathSegment)
    }
    setUsername(username: string) {
        this.username = username
        this.rankedController.username = username
    }
    setStickyUsername(username: string): void {
        setElementInnerHTML(this.usernameHeader, {key: 'strings:colonistCommon.utils.#buffer', options: {value: username}})
    }
    setUserIcon(iconImage: LobbyImage | undefined): void {
        const lobbyImage: LobbyImage = iconImage ?? LobbyImage.Guest
        setElementInnerHTML(this.stickyPlayerInfoIcon, {key: 'strings:colonistCommon.utils.emptyString'})
        createImgIn(this.stickyPlayerInfoIcon, lobbyImage, 'profile-icon')
    }

    setMembershipIcon(membershipType: ColonistMembershipType | undefined): void {
        const existingIcon = document.getElementById('sticky-player-membership-icon') as HTMLDivElement
        if(existingIcon != undefined) existingIcon.remove()

        if(membershipType == undefined) return

        const membershipIconLobbyImage = ColonistMembershipProduct.getMembershipProduct(membershipType).lobbyImage
        const membershipIcon = createImgIn(this.stickyPlayerInfoIcon, membershipIconLobbyImage, 'profile-membership-icon')
        membershipIcon.style.display = 'block'
        membershipIcon.id = 'sticky-player-membership-icon'
    }

    accountDoesNotExist(): void {
        setElementInnerHTML(this.usernameHeader, {key: 'strings:commands.errors.userDoesNotExist'})
    }

    setHistory(historyData: AjaxDataTypes.ProfileHistoryData): void {
        const {gameDatas, profileUserId} = historyData
        this.gameHistoryController.update(gameDatas, this.username, profileUserId, true)
    }

    setRankedSeasons(seasons: AjaxDataTypes.ProfileDataRankedSeasonDropdown[]): void {
        new UIProfileRankedSeasonDropdownController(seasons, this.rankedController)
    }
    setProfileSettings(userLogins: UserLoginState[]): void {
        this.settingsController.setUserLoginState(userLogins)
    }
}
